import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReactPlaceholder from 'react-placeholder'
import PaymentPlaceholder from './PaymentPlaceholder'
import { CardBrands } from './CardBrands'
import { PointsCash } from './PointsCash'
// import { getPayment } from 'Catalog/Product/ProductDetail/reducer'

class Payment extends Component {
  renderPointsCash ({ pointsCash, Cardbrands, onlyCash }) {
    const { points } = pointsCash

    if (points) {
      return (
        <Fragment>
          {onlyCash ? '' : <PointsCash {...pointsCash} />}
          <CardBrands {...Cardbrands} />
        </Fragment>
      )
    }

    return null
  }

  renderPayment (isVisible) {
    return isVisible ? (
      <div className='product-payment col-12 border-color-ui-3 py-3 px-3 mx-0 '>
        <h3 className='txt-info-product txt-body txt-font-body color-brand-1 txt-uppercase mb-1'>
          Pagamento
        </h3>
        {this.renderPointsCash(this.props)}
      </div>
    ) : (
      <div />
    )
  }

  render () {
    return (
      <div>
        <ReactPlaceholder
          ready={this.props.isVisible}
          customPlaceholder={<PaymentPlaceholder />}
        >
          {this.renderPayment(this.props.isVisible)}
        </ReactPlaceholder>
      </div>
    )
  }
}

Payment.propTypes = {
  pointsMoreCash: PropTypes.object,
  getCardBrands: PropTypes.func,
  isVisible: PropTypes.bool,
  onlyCash: PropTypes.bool
}

const mapStateToProps = ({ onlyCash, availability, catalog, payment }, { sku }) => {
  const { isPriceUpdated, price: { pointsCash: newPointCash } = {} } =
    availability[sku] || { }

  if (!isPriceUpdated) return { isVisible: false }

  const {
    currencyConfiguration: { pointsName }
  } = catalog
  const { isLoading, brands } = payment

  const isVisible =
    !!(newPointCash && newPointCash['installments'].length > 0)

  const description =
    isVisible && newPointCash['installments'][0].description

  const pointsCash = {
    currencyName: pointsName,
    points: newPointCash ? newPointCash.partialPoints : 0,
    description
  }

  const Cardbrands = { isLoading, brands }

  return ({
    onlyCash,
    isVisible,
    pointsCash,
    Cardbrands
  })
}

export default connect(mapStateToProps)(Payment)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Payment/Payment.js